import { BaseSection, Section, SectionType } from '../../../types';

export interface SectionOptions {
  title?: string;
}

export abstract class SectionFactory {
  private readonly title?: string;

  constructor(options: SectionOptions = {}) {
    this.title = options.title;
  }

  _build(): Section {
    const base: BaseSection = {
      type: SectionType.unknown,
      title: this.title,
    };

    return this.__build(base);
  }

  abstract __build(base: BaseSection): Section;
}
